import { Card, CardContent } from '@mui/material'
import { C1BorderRadius } from 'c1ui/theme/C1BorderRadius'
import { RendererProps } from 'components/a2ui/types'
import { FC } from 'react'

type CardRendererProps = Pick<RendererProps, 'component' | 'renderChildren'>

/**
 * Renders a card container with C1 border radius styling.
 */
export const CardRenderer: FC<CardRendererProps> = ({ component, renderChildren }) => {
    if (component.component.oneofKind !== 'card') return null

    const card = component.component.card
    const children = card.children?.ids ?? []

    return (
        <Card variant="outlined" sx={{ borderRadius: C1BorderRadius.large }}>
            <CardContent>
                {renderChildren(children)}
            </CardContent>
        </Card>
    )
}
